export default "__VITE_ASSET__ChLwJohN__"